import React from 'react';
import logo1 from '../../images/logo_Parle-G-Gluco-logo.webp';
import shape2 from '../../assets/img/hero/hero-bg-shape2-2.png'
import HeroThumb from '../../assets/img/hero/hero_thumb_1_1.png';
import shape3 from '../../assets/img/hero/hero-bg-shape2-4.png';
import shape4 from '../../assets/img/hero/hero-bg-shape2-3.png';

import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.min.css';
import 'owl.carousel/dist/assets/owl.theme.default.min.css';
import banner1 from '../../images/banner1.jpg';
import banner2 from '../../images/banner2.jpg';
import banner3 from '../../images/banner3.jpg';
import banner4 from '../../images/banner4.jpg';


import newbanner1 from '../../images/bannernew1.jpg';
import newbanner2 from '../../images/bannernew2.jpg';
import newbanner3 from '../../images/bannernew3.jpg';
import newbanner4 from '../../images/bannernew4.jpg';

import pdfFile3 from '../../pdf/AnnualReport2023-24.pdf'; // Adjust the path as necessary
import pdfFile4 from '../../pdf/AnnualReportGST2023.pdf';
import pdf1 from '../../images/thumb1.png'; 
import pdf2 from '../../images/thumb2.png';


const Homecount = () => {
  

  return (
<>

<div className="hero-slider newbanner">
        <OwlCarousel
          className="owl-theme"
          loop
          margin={10}
          nav
          autoplay
          autoplayTimeout={3000}
          dots
          items={1}
        >
          <div className="item">
            <img src={newbanner1} alt="Banner 1" />
          </div>
          <div className="item">
            <img src={newbanner2} alt="Banner 2" />
          </div>
          <div className="item">
            <img src={newbanner3} alt="Banner 3" />
          </div>
          <div className="item">
            <img src={newbanner4} alt="Banner 4" />
          </div>
        </OwlCarousel>
      </div>
{/* <div className="preloader ">
    <button className="th-btn style2 preloaderCls">Cancel Preloader </button>
    <div className="preloader-inner">
      <span className="loader">
        Donat
        <span className="loading-text">Donat</span>
      </span>
    </div>
  </div> */}

  <div className="sidemenu-wrapper sidemenu-cart ">
    <div className="sidemenu-content">
      <button className="closeButton sideMenuCls">
        <i className="far fa-times" />
      </button>
      <div className="widget woocommerce widget_shopping_cart">
        <h3 className="widget_title">Shopping cart</h3>
        <div className="widget_shopping_cart_content">
          <ul className="woocommerce-mini-cart cart_list product_list_widget ">
            <li className="woocommerce-mini-cart-item mini_cart_item">
              <a href="#" className="remove remove_from_cart_button">
                <i className="far fa-times" />
              </a>
              <a href="#">
                <img
                  src="assets/img/product/product_thumb_1_1.png"
                  alt="Cart Image"
                />
                Books
              </a>
              <span className="quantity">
                1 ×
                <span className="woocommerce-Price-amount amount">
                  <span className="woocommerce-Price-currencySymbol">$</span>
                  940.00
                </span>
              </span>
            </li>
            <li className="woocommerce-mini-cart-item mini_cart_item">
              <a href="#" className="remove remove_from_cart_button">
                <i className="far fa-times" />
              </a>
              <a href="#">
                <img
                  src="assets/img/product/product_thumb_1_2.png"
                  alt="Cart Image"
                />
                Medicine
              </a>
              <span className="quantity">
                1 ×
                <span className="woocommerce-Price-amount amount">
                  <span className="woocommerce-Price-currencySymbol">$</span>
                  899.00
                </span>
              </span>
            </li>
            <li className="woocommerce-mini-cart-item mini_cart_item">
              <a href="#" className="remove remove_from_cart_button">
                <i className="far fa-times" />
              </a>
              <a href="#">
                <img
                  src="assets/img/product/product_thumb_1_3.png"
                  alt="Cart Image"
                />
                Dress
              </a>
              <span className="quantity">
                1 ×
                <span className="woocommerce-Price-amount amount">
                  <span className="woocommerce-Price-currencySymbol">$</span>
                  756.00
                </span>
              </span>
            </li>
            <li className="woocommerce-mini-cart-item mini_cart_item">
              <a href="#" className="remove remove_from_cart_button">
                <i className="far fa-times" />
              </a>
              <a href="#">
                <img
                  src="assets/img/product/product_thumb_1_4.png"
                  alt="Cart Image"
                />
                Chair
              </a>
              <span className="quantity">
                1 ×
                <span className="woocommerce-Price-amount amount">
                  <span className="woocommerce-Price-currencySymbol">$</span>
                  723.00
                </span>
              </span>
            </li>
            <li className="woocommerce-mini-cart-item mini_cart_item">
              <a href="#" className="remove remove_from_cart_button">
                <i className="far fa-times" />
              </a>
              <a href="#">
                <img
                  src="assets/img/product/product_thumb_1_5.png"
                  alt="Cart Image"
                />
                Cloths
              </a>
              <span className="quantity">
                1 ×
                <span className="woocommerce-Price-amount amount">
                  <span className="woocommerce-Price-currencySymbol">$</span>
                  1080.00
                </span>
              </span>
            </li>
          </ul>
          <p className="woocommerce-mini-cart__total total">
            <strong>Subtotal:</strong>
            <span className="woocommerce-Price-amount amount">
              <span className="woocommerce-Price-currencySymbol">$</span>4398.00
            </span>
          </p>
          <p className="woocommerce-mini-cart__buttons buttons">
            <a href="cart.html" className="th-btn wc-forward">
              View cart
            </a>
            <a href="checkout.html" className="th-btn checkout wc-forward">
              Checkout
            </a>
          </p>
        </div>
      </div>
    </div>
  </div>
  <div className="popup-search-box d-none d-lg-block">
    <button className="searchClose">
      <i className="far fa-times" />
    </button>
    <form action="#">
      <input type="text" placeholder="What are you looking for?" />
      <button type="submit">
        <i className="fal fa-search" />
      </button>
    </form>
  </div>

 
  {/*==============================
	Header Area
==============================*/}
  {/*==============================
Hero Area
==============================*/}
 <div className="th-hero-wrapper hero-2" 
  id="hero" 
 
     data-overlay="gray"
  >
    <div
      className="shape-mockup hero-shape-2-1 jump"
      data-top="14%"
      data-left="5%"
    >
      <div className="color-masking">
        {/* <div
          className="masking-src"
          data-mask-src="assets/img/hero/hero-bg-shape2-1.png"
        /> */}
        {/* <img src="assets/img/hero/hero-bg-shape2-1.png" alt="shape" /> */}
      </div>
    </div>
    <div
      className="shape-mockup hero-shape-2-2 jump-reverse"
      data-top="9%"
      data-left="45%"
    >
      <img src={shape2} alt="shape" />
    </div>
    <div
      className="shape-mockup hero-shape-2-4 ripple-animation"
      data-bottom="15%"
      data-left="45%"
    >
      <div className="color-masking">
        <div
          className="masking-src"
          data-mask-src={shape3}
        />
        {/* <img src={shape3} alt="shape" /> */}
      </div>
    </div>
    <div
      className="shape-mockup hero-shape-2-5"
      data-bottom="-3%"
      data-left="8.5%"
    >
      <div className="color-masking2">
        <div
          className="masking-src"
          data-mask-src="assets/img/hero/hero-bg-shape2-5.png"
        />
        {/* <img src="assets/img/hero/hero-bg-shape2-5.png" alt="shape" /> */}
      </div>
    </div>
    <div
      className="shape-mockup hero-shape-2-6"
      data-bottom="-5%"
      data-left="3%"
    >
      <div className="color-masking">
        <div
          className="masking-src"
          data-mask-src="assets/img/hero/hero-bg-shape2-6.png"
        />
        {/* <img src="assets/img/hero/hero-bg-shape2-6.png" alt="shape" /> */}
      </div>
    </div>
    <div
      className="shape-mockup hero-shape-2-7"
      data-bottom="-7%"
      data-left="0%"
    >
      {/* <img src="assets/img/hero/hero-bg-shape2-7.png" alt="shape" /> */}
    </div>
    <div className="shape-mockup hero-shape-2-8" data-top="0%" data-right="0%">
      <div className="color-masking2">
        <div
          className="masking-src"
          data-mask-src="assets/img/hero/hero-bg-shape2-8.png"
        />
        {/* <img src="assets/img/hero/hero-bg-shape2-8.png" alt="shape" /> */}
      </div>
    </div>
    <div
      className="shape-mockup hero-shape-2-9"
      data-bottom="0%"
      data-left="0%"
      data-right={0}
    >
      {/* <img src="assets/img/hero/hero-bg-shape2-9.png" alt="shape" /> */}
    </div>
    <div className="container">
      <div className="row gx-40 align-items-center flex-row-reverse">

        <div className="col-lg-6">
 

         {/* <div className="hero-2-img">
            <img src={banner1} alt="Image" />
           
            </div> */}
             <div className="hero-slider hero2">
        <OwlCarousel
          className="owl-theme"
          loop
          margin={10}
          nav
          autoplay
          autoplayTimeout={3000}
          dots
          items={1}
        >
          <div className="item">
            <img src={banner1} alt="Banner 1" />
          </div>
          <div className="item">
            <img src={banner2} alt="Banner 2" />
          </div>
          <div className="item">
            <img src={banner3} alt="Banner 3" />
          </div>
          <div className="item">
            <img src={banner4} alt="Banner 4" />
          </div>
        </OwlCarousel>
      </div>
          
          
          
        </div>
       
        <div className="col-lg-6">
          <div className="hero-style2">
            <span className="sub-title after-none">Gram Seva Trust</span>
            <h1 className="hero-title">
              <span className="title1">
              Gram <span className="text-theme2">Seva</span>
                <div className="color-masking shake d-inline-flex">
                  <div
                     style={{
                      maskImage: `url('assets/img/hero/hero-bg-shape2-3.png')`,
                      WebkitMaskImage: `url('assets/img/hero/hero-bg-shape2-3.png')`, // For WebKit-based browsers (e.g., Chrome, Safari)
                    }}
                  
                  />
                   <img src={shape4} alt="shape" /> 
                </div>
              </span>
              <span className="title2">Turst   </span>
            </h1>
            <p className="hero-text">
            Gram seva turst Organization is work from 20+ years which work on social development
             of rural and tribes and various sector like Agriculture ,livelihood environmental
              awarness,education,nursery plantation etc.
            </p>
            <div className="btn-wrap">
              <a href="/about" className="th-btn">
                Discover Now
                <i className="fa-solid fa-arrow-up-right ms-2" />
              </a>

              {/* <a target="_blank" href={pdfFile3} > <img className='pdfimg' src={pdf1} alt=""></img></a>

<a  target="_blank" href={pdfFile4}  > <img className='pdfimg' src={pdf2} alt=""></img></a> */}
              {/* <a
                href="https://www.youtube.com/watch?v=NHsXobbyW8I"
                className="play-btn style3 popup-video"
              >
                <i className="fas fa-play" />
              </a> */}
            </div>
          </div>
        </div>


        </div>
      </div>
    </div>
 



   {/* Scroll To Top */}
   <div className="scroll-top">
    <svg
      className="progress-circle svg-content"
      width="100%"
      height="100%"
      viewBox="-1 -1 102 102"
    >
      <path
        d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
        style={{
          transition: "stroke-dashoffset 10ms linear 0s",
          strokeDasharray: "307.919, 307.919",
          strokeDashoffset: "307.919"
        }}
      />
    </svg>
  </div>
 
    
</>
  );
};

export default Homecount;
